<template>
    <div class="carContainer">
        <transition name="slide">
            <VeeForm v-slot="{ meta:formMeta }">
                <div class="my-[40px] md:my-[80px] p-0 md:px-[50px] md:py-[50px] border-0 md:border border-gray-400 rounded-2xl">
                    <div class="max-w-[1024px] mx-auto flex flex-col justify-center">
                        <div class="pb-4 flex-auto text-center text-[24px] md:text-[30px] font-medium">
                            會員註冊
                        </div>
    
                        <div class="mt-[20px]">
                            <div class="flex flex-wrap md:flex-nowrap md:gap-8 justify-between">
                                <IdField
                                    v-model="account"
                                    :plain-text="false"
                                    :member-style="true"
                                    :autofocus="true"
                                    title="帳號"
                                    name="身分證字號／居留證號"
                                    input-id="CustomerId"
                                    input-message=""
                                    placeholder="身分證字號／居留證號"
                                    rules="required|taiwanPersonalId"
                                    class="w-full"
                                />
    
                                <NameField 
                                    id="CustomerName"
                                    v-model="name"
                                    :member-style="true"
                                    placeholder="請輸入真實姓名"
                                    mode="eager"
                                    class="w-full"
                                />
                            </div>
                            
                            <div class="flex flex-wrap md:flex-nowrap md:gap-8 justify-between">
                                <MobileField 
                                    id="CustomerMobilePhone"
                                    v-model="mobile"
                                    title="手機號碼"
                                    name="手機號碼"
                                    :plain-text="false"
                                    :member-style="true"
                                    placeholder="請輸入常用手機號碼"
                                    class="w-full"
                                />
    
                                <EmailField 
                                    id="CustomerEmail"
                                    v-model="email"
                                    title="電子郵件"
                                    name="電子郵件"
                                    :plain-text="false"
                                    :member-style="true"
                                    placeholder="請輸入常用email"
                                    class="w-full"
                                />
                            </div>

                            <BirthdayField
                                v-model="birthday"
                                :assured-style="true"
                                :plain-text="false"
                                :member-style="true"
                            />
                            
                            <div class="mt-8 p-4 leading-6 border border-yellow-800 bg-yellow-200 rounded-[20px]">
                                <p><span class="text-pink-800">會員即是要保人</span>，原則上為車主本人或其親友，可取得車主及車輛相關資訊及聯絡方式；車輛若登記為法人，會員應由負責人或辦理投保之員工名義申請註冊。</p>
                                <p><span class="text-pink-800">線上投保限由要保人(會員)或車主之信用卡或帳戶繳交保費。</span></p>
                            </div>
                        </div>
    
                        <div
                            id="agreement"
                            class="text-[18px] font-bold text-blue-700 text-center py-[15px] border-l-8 border-blue-700 bg-blue-500 mb-[40px] mt-[50px] text-center"
                        >
                            同意聲明告知事項
                        </div>
    
                        <div>
                            <Agreement
                                :terms="terms"
                                :confirmed="confirmed"
                                @confirm="confirmed = true"
                            />
    
                            <VeeField
                                v-slot="{value}"
                                v-model="confirmed"
                                name="hiddenConfirm"
                                rules="required"
                            >
                                <input
                                    :model-value="value"
                                    type="hidden"
                                >
                            </VeeField>
                            <div class="mt-4 flex items-start gap-x-2">
                                <div class="mt-0.5 shrink-0">
                                    <img
                                        src="@/assets/images/icons/bell.svg"
                                        loading="lazy"
                                        alt="bell"
                                        class="w-[20px]"
                                    >
                                </div>
                                <div class="flex-1">
                                    本公司所蒐集之個人資料並無共同行銷或屬保險以外且具正當合理關聯之特定項目。
                                </div>
                            </div>
                            <div>
                                <VeeField
                                    v-slot="{ value, handleChange }"
                                    v-model="readAgreement"
                                    name="同意聲明"
                                    rules="required"
                                >
                                    <FormCheckBox
                                        :model-value="value"
                                        text="我已閱讀並同意上述聲明"
                                        icon-type="filled"
                                        :disabled="!confirmed"
                                        class="mt-[10px] font-bold"
                                        @update:model-value="handleChange"
                                    />
                                </VeeField>
                                <VeeField
                                    v-slot="{ value, handleChange }"
                                    v-model="agreement"
                                    name="同意事項"
                                    rules="required"
                                >
                                    <FormCheckBox
                                        :model-value="value"
                                        text="同意註冊成為新安東京海上網路投保會員"
                                        icon-type="filled"
                                        class="mt-[10px] font-bold"
                                        @update:model-value="handleChange"
                                    />
                                </VeeField>
                            </div>
                        </div>
                    </div>
                </div>   

                <div class="max-w-3xl mx-auto flex flex-col justify-center">
                    <div class="flex align-center gap-[30px] md:gap-[60px] mx-auto">
                        <FormButton
                            data-accuid="Register_Back"
                            text="返回"
                            outline
                            @click="onBack"
                        />
                        <FormButton
                            data-accuid="Register_Confirm"
                            text="發送註冊驗證碼"
                            :disabled="!formMeta.valid || !birthday"
                            @click="onSubmit"
                        />
                    </div>
                </div>
            </VeeForm>
        </transition>
    </div>
</template>

<script>
import FormButton from '@/components/forms/Button';
import FormCheckBox from '@/components/forms/CheckBox';
import Agreement from '@/components/Agreement';
import MobileField from '@/components/forms/fields/Mobile';
import EmailField from '@/components/forms/fields/Email';
import NameField from '@/components/forms/fields/Name';
import IdField from '@/components/forms/fields/Id';
import BirthdayField from '@/components/forms/fields/Birthday';

/**
 * 註冊表單
 */
export default {
    name: 'RegisterForm',
    components: {
        Agreement,
        FormCheckBox,
        FormButton,
        MobileField,
        EmailField,
        NameField,
        IdField,
        BirthdayField
    },
    data() {
        /**
         * @param {Boolean} readAgreement 我已閱讀並同意上述聲明是否打勾
         * @param {Boolean} agreement 同意註冊成為新安東京海上網路投保會員的條款是否打勾
         * @param {String} account 帳號：身分證字號或居留證號
         * @param {Boolean} confirmed 是否閱讀過條款
         * @param {String} email 電子郵件帳號
         * @param {String} mobile 手機號碼
         * @param {String} name 姓名
         * @param {String} birthday 生日
         * @param {Array} terms 要抓取的條款有哪些
         */
        return {
            readAgreement: false,
            agreement: false,
            account: null,
            confirmed: false,
            email: null,
            mobile: null,
            name: null,
            birthday: null,
            terms: [
                {InsCategory: 'Common', NoteType: 2},
                {InsCategory: 'Common', NoteType: 1},
                {InsCategory: this.$route.params.type === 'car'? 'Car' : 'Motorcycle', NoteType: 4},
                {InsCategory: 'Common', NoteType: 3}
            ],
            to: this.$store.state.nav.to || {name: 'Home'},
            from: this.$store.state.nav.from || {name: 'Home'}
        };
    },
    mounted() {
        this.$store.commit('terms/setAllUnread');
        this.pushDataLayerForPageView();
    },
    methods: {
        /**
         * 到上一步
         * 
         * @public
         */        
        onBack() {
            this.$router.push(this.from);
        },
        /**
         * 點擊寄送驗證碼，發送表單
         * 
         * @public
         */
        onSubmit() {
            this.$store.commit('showLoading');

            this.$store.commit('auth/setAccount', this.account);
            this.$store.commit('member/setId', this.account);
            this.$store.commit('member/setName', this.name);
            this.$store.commit('member/setEmail', this.email);
            this.$store.commit('member/setMobile', this.mobile);
            this.$store.commit('member/setBirthday', this.birthday);

            // 如果 store 已存有未過期的 register otp 資料，並且 id 與本次相同，直接轉到 otp 頁
            if (this.$store.getters['otp/registerOtpCodeAvailableWithId'](this.account)) return this.$router.push(`/${this.$route.params.type}/register/otp`);

            axios.post(apiUrl.Register, {
                account: this.account,
                name: this.name,
                mobile: this.mobile,
                email: this.email,
                birthday: this.birthday,
                sourceRemark: this.$store.state.insCategory === 'Car' ? '汽車險' : '機車險'
            }).then(res => {

                if (res.data.code === 200) {
                    this.$store.commit('otp/setRegister', {
                        email: res.data.data.otpEmail,
                        id: res.data.data.otpId,
                        mobile: res.data.data.otpMobile,
                        frontCode: res.data.data.otpFrontCode,
                        expired: res.data.data.otpExpireTime,
                        // api沒回傳
                        birthday: this.birthday
                    });

                    this.$store.commit('auth/setBirthday', this.birthday);
                    this.$store.commit('member/setBirthday', this.birthday);

                    this.$store.commit('nav/setAll', {to: this.to, clear: true, params: {type: this.$route.params.type}});
                    return this.$router.push({ name: 'RegisterOtp' });

                } else {

                    this.$store.commit('setDialog', {
                        title: '註冊失敗',
                        text: res.data.message,
                        active: true
                    });
                    this.$store.commit('closeLoading');
                }

            }).catch(err => {
                this.$store.commit('setDialog', {
                    title: '註冊失敗',
                    text: err.response?.data?.message || '系統忙碌中，請稍候再試',
                    active: true
                });
                this.$store.commit('closeLoading');
            });
        },
        /**
         * 推送GA4 DataLayer page_view
         */
        pushDataLayerForPageView(){
            let item = {
                pageUrl: window.location.href,
                pageTitle: document.title
            };
            this.$ga.pushDataLayerForPageView(item);
        }
    }
};
</script>

<style scoped>
.slide-enter-active, .slide-leave-active {
    transition: all .3s ease;
}

.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */
{
    transform: translateY(20px);
}
::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-button {
    background: transparent;
    border-radius: 4px;
}

::-webkit-scrollbar-track-piece {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: #005BAC;
}

::-webkit-scrollbar-track {
    box-shadow: transparent;
}
</style>